import { eventBus } from '@/main';
import {
  DisplayModule,
  RouterModule,
  SectionsModule,
  UsersModule,
  ArgumentsModule,
  CommentsModule,
  DocumentsModule,
  NotificationsModule
} from '@/store/store.helper';
import { SectionInterface } from '@/types/interfaces';
import * as enums from '@/types/enums';
import { NavBarInterface, NAVBAR_SIDE_ICON } from '@/store/types';
import SectionCard from '@/components/section.card/section.card';
import Summary from '@/views/Document/Summary/Summary';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { DYNAMIC_PAGES } from '@/types/constants';
import * as VueScrollTo from "vue-scrollto";

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
@Component({
  components: {
    SectionCard,
    Summary
  },
})
export default class Vote extends Vue {
  @DisplayModule.DisplayGetter public getColor: (number) => string;
  @DisplayModule.DisplayGetter public scrollingOptions;
  @DisplayModule.DisplayMutation public setNavBar;

  @RouterModule.RouterGetter private currentRoute;
  @RouterModule.RouterGetter private getPath;
  @RouterModule.RouterAction private pushWithParams;
  @RouterModule.RouterAction private push;

  @UsersModule.UsersGetter private isSignedIn;
  @UsersModule.UsersAction private signIn;
  @UsersModule.UsersAction private checkUserProperties;
  @UsersModule.UsersGetter private userUid;
  @UsersModule.UsersGetter private user;
  @UsersModule.UsersGetter private isUserSubscribedToSectionNotifications;
  @UsersModule.UsersAction private updateCurrentUser;

  @DisplayModule.DisplayGetter private snackbar;
  @DisplayModule.DisplayMutation private closeSnackbar;

  @SectionsModule.SectionsGetter private sectionsByStatus;
  @SectionsModule.SectionsGetter private sectionsByTopicsAndStatuses;
  @SectionsModule.SectionsGetter private sectionById;
  @SectionsModule.SectionsGetter private allSections;
  @SectionsModule.SectionsGetter private isParentSection;
  @SectionsModule.SectionsGetter private initialParentId;
  @SectionsModule.SectionsGetter private sectionRejectedLength;
  @SectionsModule.SectionsGetter private isDynamicFeed: (pageStatus) => boolean;
  @SectionsModule.SectionsAction private updateSection;

  @CommentsModule.CommentsGetter private commentById;

  @ArgumentsModule.ArgumentsGetter private argumentById;
  @DocumentsModule.DocumentsGetter private documentWelcome;
  @DocumentsModule.DocumentsGetter private documentSortBy;
  @DocumentsModule.DocumentsGetter private documentTopics;
  @NotificationsModule.NotificationsAction private checkFcmRegistrationToken;
  private sectionByFunction;
  private sectionByKey;
  private sectionByValue = '';
  private sectionIndex: number = 1;
  private currentIndex: number = 0;
  private isFeedIsDiscussion: boolean;
  private isShowNext: boolean = true;
  private sections: any;
  private suggestionNotification: boolean = false;
  private lastIndex: number = -1;
  // This enums silly assignment is needed in order to prevent the 'Property or method "enums" is not defined on the instance but referenced during render' Error
  private enums = enums;
  private transition = false;
  private topics = localStorage.checkedList.split(',');
  private notificationsOnSnackBar: boolean = false;
  @Watch('$route', { immediate: true, deep: true })
  private onUrlChange(to, from) {
    console.log('Section.ts URL Change' + (from ? ' from ' + from : '') + ' to ' + to.path);
    this.mountFeed();
  }
  @Watch('sectionTopics', { immediate: true, deep: true })
  private onSectionChange(to, from) {
    if (!from) return;
    if (to.length > from.length) {
      // this.$router.replace({name: 'vote', query: { 'index': (to.length).toString()}});
      this.sections.push(to[to.length - 1]);
      this.lastIndex = this.currentIndex;
      this.currentIndex = to.length - 1;
      localStorage.setItem('current', this.currentIndex.toString());
      this.$forceUpdate();
    }
  }
  get sectionTopics() {
    const statuses = this.documentSortBy === 'createdAt' || this.sectionsByTopicsAndStatuses(localStorage.checkedList.split(','), [enums.SECTION_STATUS.inTheVote]).length === 0
      ? [enums.SECTION_STATUS.inTheVote, enums.SECTION_STATUS.approved]
      : [enums.SECTION_STATUS.inTheVote];
    console.log("statuses", statuses);
    return this.sectionsByTopicsAndStatuses(localStorage.checkedList.split(','), statuses);
  }

  get pageStatus(): number {
    if (this.sections.length) {
      return this.sections[this.currentIndex].status === this.enums.SECTION_STATUS.toEdit || this.sections[this.currentIndex].status === this.enums.SECTION_STATUS.toEditInTheVote
        ? this.enums.FEED_TYPE.toEditSectionSuggestion
        : this.enums.SECTION_STATUS.inTheVote;
    } else {
      return this.enums.SECTION_STATUS.inTheVote;
    }
  }

  private sortedSections() {
    if (this.documentSortBy === 'createdAt') {
      const topics = this.documentTopics;
      return this.sectionTopics.slice()
        .sort((sectionA: SectionInterface, sectionB: SectionInterface) =>
          topics.indexOf(sectionA.topic) > topics.indexOf(sectionB.topic) ? 1 : topics.indexOf(sectionA.topic) < topics.indexOf(sectionB.topic) ? -1 :
            new Date(sectionA.createdAt).getTime() - new Date(sectionB.createdAt).getTime()
        );
    } else {
      return this.sectionTopics.slice()
        .sort((sectionA: SectionInterface, sectionB: SectionInterface) =>
          sectionA.threshold + sectionA.cons.length - sectionA.pros.length - sectionB.threshold - sectionB.cons.length + sectionB.pros.length ||
          new Date(sectionB.createdAt).getTime() - new Date(sectionA.createdAt).getTime()
        );
    }
  }

  get sortedByThreshold() {
    return this.sections
      .sort((sectionA: SectionInterface, sectionB: SectionInterface) =>
        sectionA.threshold + sectionA.cons.length - sectionA.pros.length - sectionB.threshold - sectionB.cons.length + sectionB.pros.length ||
        new Date(sectionB.createdAt).getTime() - new Date(sectionA.createdAt).getTime()
      );
  }

  get parentSectionId() {
    return this.sections[this.currentIndex].parentSectionId
  }

  /**
   * gets the params from the route
   * getting section by id / getting sections by status
   */
  private async mountFeed() {
    this.sections = this.sortedSections();
    this.isFeedIsDiscussion = DYNAMIC_PAGES.includes(this.pageStatus);
    this.buildComponentBySectionsStatus();
    this.$root.$on('backSuggestion', () => {
      this.navigateToBack();
    });

    this.currentIndex = this.$route.params.index
      ? 0
      : localStorage.getItem('current') && Number(localStorage.getItem('current')) <= this.sections.length
        ? Number(localStorage.getItem('current'))
        : 0;
    localStorage.setItem('current', this.currentIndex.toString());
    this.checkNotification();
    eventBus.$on('nextBtn', display => this.isShowNext = display);
    eventBus.$on('mountVoteFeed', () => {
      this.mountFeed();
    });
    eventBus.$on('argumentAdded', this.enableNotification);
    this.scrollToArgument();
    this.listenToEventGoToParentSection();
  }
  private listenToEventGoToParentSection() {
    eventBus.$on('goToSection', (sectionId) => {
      this.goToSection(sectionId);
    });
    if (localStorage.getItem('lastSectionId')) {
      this.goToSection(localStorage.getItem('lastSectionId'));
      localStorage.removeItem('lastSectionId');
    }
  }
  private goToSection(sectionId) {
    this.currentIndex = this.sections.findIndex(section => section.id === sectionId);
    localStorage.setItem('current', this.currentIndex.toString());
    this.checkNotification();
    window.scrollTo(0, 0);
  }
  private checkNotification() {
    this.transition = !this.transition;
    this.suggestionNotification = false;
    try {
      if (this.user.notifications.suggestionsNotifications[this.sections[this.currentIndex].id] === true) {
        this.suggestionNotification = true;
      }
    } catch (e) { }
  }
  private beforeDestroy() {
    this.$root.$off("backSuggestion");
    eventBus.$off('nextBtn');
    eventBus.$off('goToSection');
    eventBus.$off('scrollTo');
    eventBus.$off('mountVoteFeed');
    eventBus.$off('argumentAdded');
  }
  private getParams() {
    const params = [this.sectionByValue];
    if ('id' in this.$route.query) {
      // @ts-ignore
      params.push(this.$route.query.id);
    }
    return params;
  }

  // TODO: scrolling directive

  /**
   * scrolling to specifics argument
   */
  private scrollToArgument() {
    eventBus.$on('scrollTo', (payload) => {
      const { scrollTo, scrollId } = payload;
      let sectionId;
      if (!scrollTo) { return; }
      const id = scrollId;
      if (scrollTo === 'comment') {
        const comment = this.commentById(id);
        const argId = comment.argumentId;
        sectionId = this.argumentById(argId).sectionId;
        eventBus.$emit('toggleArguments', { sectionId, toDisplay: true });
        eventBus.$emit('toggleComments', argId);
      } else if (scrollTo === 'argument') {
        sectionId = this.argumentById(id).sectionId;
        eventBus.$emit('toggleArguments', { sectionId, toDisplay: true });
      } else {
        sectionId = id;
      }
      if (this.$refs[sectionId] === undefined) { return; }
      if (scrollTo === 'argument') {
        this.scrollingOptions.offset = 0;
        // @ts-ignore
        VueScrollTo.scrollTo(this.$refs[sectionId].$el, 1500, this.scrollingOptions);
      } else {
        // @ts-ignore
        this.scrollingOptions.offset = this.$refs[sectionId].$el.clientHeight - 500;
        // @ts-ignore
        VueScrollTo.scrollTo(this.$refs[sectionId].$el, 1500, this.scrollingOptions);
      }
    });
  }

  /**
   * get section Index from router
   * setting the nav bar of the component
   */
  private buildComponentBySectionsStatus() {
    this.sectionIndex = 'index' in this.$route.query ? parseInt(<string>this.$route.query.index) : 1;
    const navBarPref: NavBarInterface = {
      title: 'דיון בהצעה',
      color: this.getColor(this.pageStatus),
      icon: NAVBAR_SIDE_ICON.menu
    };
    this.setNavBar(navBarPref);
  }

  /**
   * adds new section
   */
  private async addNewSection() {
    if (!this.isSignedIn) {
      this.signIn();
    } else {
      this.checkUserProperties();
      const pushToParams = {
        type: 'section',
        action: enums.SECTION_STATUS.inTheVote,
        sectionId: 0,
        parentSectionId: '0',
      };
      if (this.sections.length) { localStorage.setItem('lastSectionId', this.sections[this.currentIndex].id); }
      this.pushWithParams({ name: enums.ROUTE_NAME.addNew, params: pushToParams });
    }
  }

  private showAddButton() {
    return this.pageStatus === enums.FEED_TYPE.inTheVote || this.pageStatus === enums.FEED_TYPE.toEdit || this.pageStatus === enums.FEED_TYPE.sectionApproved || this.pageStatus === enums.FEED_TYPE.edited;
  }
  /**
   * get Nav Bar title by FEED_TYPE
   */

  private navigateToRejectedFeed(): void {
    const path = this.getPath({
      name: enums.ROUTE_NAME.section,
      params: {
        [enums.SECTION_BY.sectionsByStatus]: enums.SECTION_STATUS.rejected,
        id: this.parentSectionId,
      },
    });

    this.setNavBar({ path: this.currentRoute.fullPath });
    this.push({ path });
  }

  private isRejectedFeed() {
    return this.pageStatus === enums.FEED_TYPE.rejected;
  }

  /**
   * Turns on the notification configuration for the current suggestion
   */
  private enableNotification() {
    this.suggestionNotification = true;
    this.updateNotification();
  }


  private navigateToNext() {
    if (this.currentIndex < this.sections.length) {
      this.currentIndex += 1;
      localStorage.setItem('current', this.currentIndex.toString());
      this.checkNotification();
      // this.$router.replace({name: 'vote', query: { 'index': (this.currentIndex + 2).toString()}, });
      window.scrollTo(0, 0);
    }
  }

  private navigateToBack() {
    if (this.currentIndex > 0) {
      if (this.lastIndex > -1) {
        this.currentIndex = this.lastIndex;
        this.lastIndex = -1;
      } else {
        this.currentIndex -= 1;
      }
      localStorage.setItem('current', this.currentIndex.toString());
      this.checkNotification();
      // this.$router.replace({name: 'vote', query: { 'index': (this.currentIndex).toString()}});
    } else if (this.currentIndex === 0) {
      localStorage.setItem('current', this.currentIndex.toString());
      this.checkNotification();
      this.$router.push({ name: enums.ROUTE_NAME.chooseTopics });
    }
    window.scrollTo(0, 0);
  }
  private navigateTo(to): void {
    this.$router.push({ name: to })
  }
  private async updateNotification() {
    if (!this.isSignedIn) {
      this.signIn();
      return;
    }
    let suggestionsNotifications, notifications;
    try {
      if ('suggestionsNotifications' in this.user.notifications) {
        suggestionsNotifications = Object.assign({}, this.user.notifications.suggestionsNotifications);
      } else {
        suggestionsNotifications = {};
      }
      suggestionsNotifications[this.sections[this.currentIndex].id] = this.suggestionNotification;
      notifications = { ...this.user.notifications, suggestionsNotifications };
    } catch (e) {
      suggestionsNotifications = {};
      suggestionsNotifications[this.sections[this.currentIndex].id] = this.suggestionNotification;
      notifications = { suggestionsNotifications };
    }
    const isUserSubscribed = this.isUserSubscribedToSectionNotifications(this.sections[this.currentIndex].id)
    if (this.suggestionNotification && !isUserSubscribed) {
      this.notificationsOnSnackBar = true
    }
    await this.updateCurrentUser({
      updateObject: { notifications }
    });
    this.user.notifications = notifications;

    this.checkFcmRegistrationToken();
  }

  private closeNotificationSnackbar() {
    this.notificationsOnSnackBar = false;
  }

  private voteOnNewSections(): void {
    const navbar = { path: this.currentRoute.fullPath };
    console.log('Draft.ts Set navbar ' + JSON.stringify(navbar));
    this.setNavBar(navbar);
    const path = this.getPath({
      name: enums.ROUTE_NAME.section,
      params: {
        sectionsByStatus: enums.SECTION_STATUS.inTheVote,
      },
    });
    console.log('Draft.ts Push path ' + path);
    this.push({ path });
  }

  private onClickBack() {
    this.$root.$emit('backSuggestion');
  }
}
